import { Select } from '@radix-ui/themes';
import {
  useGetSlackChannelsQuery,
  GetSlackChannelsQuery,
} from '../../graphql/queries/GetSlackChannels.generated';

type SlackChannelNode =
  GetSlackChannelsQuery['slackChannels']['edges'][0]['node'];

interface SlackInstallationChannelSelectProps {
  installationId?: string;
  channelId?: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
}

const SlackInstallationChannelSelect = ({
  installationId,
  channelId,
  onValueChange,
  disabled,
}: SlackInstallationChannelSelectProps) => {
  const isDisabled = disabled || !installationId;
  const { data, loading, error } = useGetSlackChannelsQuery({
    variables: { installationId: installationId! },
    skip: !installationId,
  });

  if (!installationId) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger
          placeholder="Select a workspace first"
          style={{ width: '100%' }}
        />
      </Select.Root>
    );
  }

  if (loading) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger
          placeholder="Loading channels..."
          style={{ width: '100%' }}
        />
      </Select.Root>
    );
  }

  if (error || !data) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger
          placeholder="Error loading channels"
          style={{ width: '100%' }}
        />
      </Select.Root>
    );
  }

  const channels: SlackChannelNode[] = data.slackChannels.edges
    .map((edge) => edge.node)
    .filter((channel) => !channel.isArchived);

  return (
    <Select.Root
      value={channelId}
      onValueChange={onValueChange}
      disabled={isDisabled}
    >
      <Select.Trigger
        placeholder={
          channels.length === 0 ? 'No channels found' : 'Select a channel'
        }
        style={{ width: '100%' }}
      />
      <Select.Content>
        {channels.map((channel) => (
          <Select.Item key={channel.id} value={channel.slackChannelId}>
            #{channel.name || channel.slackChannelId}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
};

export default SlackInstallationChannelSelect;
